import { entityStatusSideMsgValue } from '#/modules/commonComponents/table/entityStatusIconHelpers';

function dash(value) {
  if (value === null || value === undefined || value === '') {
    return '-';
  }
  return value;
}

function resolveCustomerLabel(row, customerLabelCache) {
  if (!row?.customerId) {
    return '-';
  }
  return customerLabelCache?.get(String(row.customerId)) || '-';
}

/** Block A：僅狀態 */
export const productSideMsgStatusBlock = {
  fields: [
    {
      key: 'status',
      label: '狀態',
      render: (row) => (
        <div className="side_msg-row">
          <h3>狀態</h3>
          {entityStatusSideMsgValue(row)}
        </div>
      ),
    },
  ],
};

/** Block C：主檔摘要 */
export function buildProductSideMsgDetailBlock(customerLabelCache) {
  return {
    fields: [
      { label: '產品代號', value: 'productNo' },
      { label: '名稱', value: 'name' },
      { label: '客戶', value: (row) => resolveCustomerLabel(row, customerLabelCache) },
      { label: '客戶料號', value: (row) => dash(row?.customerProductNo) },
      { label: '銷售單位', value: (row) => dash(row?.salesUnitName) },
      { label: '備註', value: (row) => dash(row?.remark) },
    ],
  };
}
